module.exports = __webpack_public_path__ + "static/media/virgin-money.066c52a6.svg";